// Testing
export const DEBUG = true;

/**
 * Key for local storage.
 *
 * Set the key to use in local storage to hold persistant data. If logged in,
 * you can see this key by going to Chrome > dev tools > application tab,
 * then choosing "Local Storage" and "http://localhost:8080".
 *
 * @type {string}
 */
 export const STORAGE_KEY = 'hsia-login-spa'

 export const GUEST_AUTHENTICATION_HOST = function() {
 	let guestAuthenticationHost = 'https://guest-authentication-zone-service.sandbox.aws.corp.cloud5.com/api/v1';

 	if (process.env.GUEST_AUTHENTICATION_HOST) {
 		guestAuthenticationHost = process.env.GUEST_AUTHENTICATION_HOST;
 	}

 	return guestAuthenticationHost;
 }

 export const ENTITY_SERVICE_HOST = function() {
 	let entityServiceHost = 'http://cloud5-dev.apigee.net/entity-service';

 	if (process.env.ENTITY_SERVICE_HOST) {
 		entityServiceHost = process.env.ENTITY_SERVICE_HOST;
 	}

 	return entityServiceHost;
 }